export function getTabIndex(element: HTMLElement): number {
    // Workaround for Chromium versions 107-118 returning a tabindex of -1 for audio/video/details elements which do not have a tabindex attribute explicitly set
    if (!element.hasAttribute("tabindex") && (element.isContentEditable || ["AUDIO", "VIDEO", "DETAILS"].includes(element.tagName))) {
        return 0;
    }

    return element.tabIndex;
}
